import * as React from "react";

import { NonIdealState } from "@blueprintjs/core";
import Loader from "~/components/Loader";
import client from "~/graphql/client";
import {
  IModerationOption,
  OPTIONS_PENDING_REMODERATION_QUERY,
  OptionsPendingRemoderation,
  OptionsPendingRemoderationVariables
} from "~/graphql/queries/optionRemoderation/optionsPendingRemoderation";
import RemoderationFormContainer from "./RemoderationFormContainer";

interface IState {
  loadingCount: number;
  queue: IModerationOption[];
}

export default class RemoderationQueueContainer extends React.Component<
  {},
  IState
> {
  public readonly state: IState = {
    loadingCount: 0,
    queue: []
  };

  public render() {
    const { queue, loadingCount } = this.state;

    if (loadingCount > 0) {
      return <Loader />;
    }

    if (!queue.length) {
      return (
        <NonIdealState
          icon="error"
          title="Unable to find more"
          description="Please fix other lines first."
        />
      );
    }

    const moderationOption = queue[0];

    return (
      <RemoderationFormContainer
        moderationOption={moderationOption}
        onNextModerationOption={this.handleNextModerationOption}
      />
    );
  }

  public componentDidMount() {
    this.loadOptions(5);
  }

  private handleNextModerationOption = () => {
    this.loadOptions(1);

    this.setState(state => {
      const moderationOption = state.queue.slice(1)[0];
      if (
        !moderationOption.image ||
        moderationOption.image.status !== "uploaded"
      ) {
        this.handleNextModerationOption();
      }

      return {
        ...state,
        queue: state.queue.slice(1)
      };
    });
  };

  private async loadOptions(count: number) {
    this.setState(state => ({ loadingCount: state.loadingCount + 1 }));
    const { data } = await client.query<
      OptionsPendingRemoderation,
      OptionsPendingRemoderationVariables
    >({
      fetchPolicy: "network-only",
      query: OPTIONS_PENDING_REMODERATION_QUERY,
      variables: {
        count
      }
    });

    this.setState(state => ({
      loadingCount: state.loadingCount - 1,
      queue: [...state.queue, ...data.moderationOptions]
    }));
  }
}



// WEBPACK FOOTER //
// ./src/containers/RemoderationQueueContainer.tsx